const getFileType = (file) => {
  const fileTypeRegex = /\.[a-zA-Z]+/i;

  return file?.match(fileTypeRegex)[0];
};

export default getFileType;
